import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'genderString',
  standalone: true,
})
export class GenderStringPipe implements PipeTransform {
  transform(value: string | undefined): string {
    switch (value) {
      case 'f':
        return 'weiblich';
      case 'm':
        return 'männlich';
      default:
        return '';
    }
  }
}
